import { render, staticRenderFns } from "./checkItem.vue?vue&type=template&id=06d427e9&scoped=true&"
import script from "./checkItem.vue?vue&type=script&lang=js&"
export * from "./checkItem.vue?vue&type=script&lang=js&"
import style0 from "./checkItem.vue?vue&type=style&index=0&id=06d427e9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d427e9",
  null
  
)

export default component.exports